export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    content: string
    enableMermaid: boolean
    brandTheme: boolean
}

const MERMAID_CONTENT = `\`\`\`mermaid
flowchart LR
    A[需求输入] --> B{方案评审}
    B -->|通过| C[方案实现]
    B -->|补充信息| D[补充需求]
    D --> B
    C --> E[联调验证]
    E --> F[发版验证]
\`\`\``;

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            content: MERMAID_CONTENT,
            enableMermaid: true,
            brandTheme: false,
        };
    }

    getMermaidConfig() {
        if (!this.get('brandTheme')) return undefined;

        return {
            theme: 'base',
            themeVariables: {
                primaryColor: '#e8f3ff',
                primaryBorderColor: '#1677ff',
                primaryTextColor: '#244055',
                lineColor: '#1677ff',
                secondaryColor: '#fff7e8',
                tertiaryColor: '#f6fbff',
            },
        };
    }

    @bind
    setEnableMermaid(enableMermaid?: boolean) {
        this.set('enableMermaid', !!enableMermaid);
    }

    @bind
    setBrandTheme(brandTheme?: boolean) {
        this.set('brandTheme', !!brandTheme);
    }
}